import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  VARIABLE_BUTTON: `${cleanedFilename(__filename)}-variable-button`,
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
  CHECK_BUTTON: `${cleanedFilename(__filename)}-check-button`,
};
